import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import EntityChatView from 'src/components/EntityChatView';
import { toEntityChatSalesRep } from 'src/components/EntityChatView/helpers';
import { IEntityChatMember } from 'src/components/EntityChatView/interface';
import { orderDetailsData } from 'src/redux/orders.slice';

interface IOrderMessagesProps {
    orderId: string | number;
    orderConnectedUsers?: IEntityChatMember[];
    mainLoading?: boolean;
    isActive?: boolean;
}

const OrderMessages: React.FC<IOrderMessagesProps> = ({ orderId, orderConnectedUsers = [], mainLoading, isActive }) => {
    const order = useSelector(orderDetailsData);

    // The order's assigned sales rep (orderDetail.service flattens it onto the order payload) so the
    // chat header can show the rep even when the customer has no customer-level rep yet.
    const entitySalesRep = useMemo(
        () =>
            toEntityChatSalesRep({
                firstName: order?.salesRepFirstName,
                lastName: order?.salesRepLastName,
                image: order?.salesImage,
                imageUrl: order?.salesImageUrl,
            }),
        [order?.salesRepFirstName, order?.salesRepLastName, order?.salesImage, order?.salesImageUrl]
    );

    return <EntityChatView entityId={orderId} entityType="order" connectedUsers={orderConnectedUsers} mainLoading={mainLoading} isActive={isActive} entitySalesRep={entitySalesRep} />;
};

export default OrderMessages;
